import { useContext, useEffect, useMemo } from 'react'
import objectPath from 'object-path'
import { DesignContext } from 'contexts/DesignContext'

import { Form, Col, Row } from 'react-bootstrap'
import moment from 'moment'
import Label from './Label'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import TimePickerInput from './TimePicker/TimePickerInput'
import { createUischemaStyle } from './Style'

const CustomTime = (props) => {
  let {
    uischema,
    updateData,
    copyData = () => {},
    errors = {},
    time,
    label,
    setIsOnChange,
    fieldName,
    fieldKey,
  } = props
  let { key, elementWidth, controlId, suffixText, require, formatType } =
    uischema

  let errorArray = objectPath.get(errors, key) || []

  const designContext = useContext(DesignContext)
  const { elementAction } = designContext
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', key])
  let requireMessage = objectPath.get(elementAction, ['isRequire', key])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  let showRequire = time ? false : isRequire ? true : false

  let hasWarning = objectPath.has(elementAction, ['isWarning', key])
  let warningMessage = objectPath.get(elementAction, ['isWarning', key])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage

  const uiStyle = useMemo(
    () => createUischemaStyle({ uischema, showRequire }),
    [uischema, showRequire],
  )

  let date = moment().format('YYYY-MM-DD')

  let dateTime = useMemo(() => {
    if (time) {
      return `${date} ${time}`
    }
    return null
  }, [time, uischema.timeFormat, uischema.time])

  let { timeFormat, formatTime } = useTimeFormat()
  const isCustomFormat = formatType === 'custom'

  const formatTimeDisplay = useMemo(() => {
    if (isCustomFormat) {
      return uischema.timeFormat
    }
    return timeFormat
  }, [formatType, uischema.timeFormat, uischema.time])

  return (
    <Form.Group className="mb-0" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isRequire={isRequire}
          isEnable={!isReadOnly}
        />
        <Col sm={elementWidth} className="mt-1 p-0">
          <div className="d-flex">
            {isReadOnly ? (
              <Form.Control
                type="text"
                value={formatTime(dateTime, timeFormat)}
                readOnly
              />
            ) : (
              <TimePickerInput
                id={fieldKey}
                name={fieldName}
                formatDisplay={formatTimeDisplay}
                style={uiStyle}
                ampm={uischema.time === '12' ? true : false}
                validateInput
                value={time}
                onChange={(e) => {
                  let time = { value: e }
                  updateData(time, true)
                  copyData(time)
                  setIsOnChange(true)
                }}
                uischema={uischema}
              />
            )}
          </div>
        </Col>
        {suffixText && (
          <Col className="d-flex align-items-center mt-1 pr-0" sm="auto">
            <Form.Label className={`m-0 w-100`}>{suffixText}</Form.Label>
          </Col>
        )}
      </Row>
      <ul className="m-0 mt-2">
        {showRequire && showRequireMessage && requireMessage && (
          <li className="text-danger">{requireMessage}</li>
        )}
        {showWarningMessage && warningMessage && (
          <li className="text-danger">{warningMessage}</li>
        )}
        {errorArray.map((error, index) => (
          <li key={`error-${key}-${index + 1}`} className="text-danger">
            {error}
          </li>
        ))}
      </ul>
    </Form.Group>
  )
}

export default CustomTime
